import Table from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/Table/Table";
import { useTheme } from "@ihs-widget/stores/ThemeContext";
import { T } from "@ihs-widget/utils/enums";

interface GroupTableProps {
    groupsData: {
        leagueName: string;
        groups: Array<{
            groupName: string;
            tableRows: Array<{
                no: number;
                teamName: string;
                leagueName: string;
                playedMatches: number;
                plusMinus: string;
                points: number;
                from: string[];
                qualification: string;
                qualificationRaw: string;
                color: string | null;
            }>;
            
        }>
        colorLegend: Array<{
            color: string;
            label: string;
            description: string;
        }>;
    };
}

const GroupTable = ({ groupsData }: GroupTableProps) => {
    const { theme } = useTheme();

    return (
        <div className="w-full mt-[20px] ">
            <div className="text-center">
                <div 
                    className="text-[12px] leading-[16px] font-robotoMedium font-medium text-monoX dark:text-monoY mb-[24px]"
                >
                    {groupsData.leagueName}
                </div>
            </div>
            <div className="w-full ">
                {groupsData.groups.map((group, groupIndex) => (
                    <div key={groupIndex} className="w-full flex flex-col justify-center items-center">
                        <div className="sm351:w-[319px] w-full">
                            <div 
                                className="text-[12px] leading-[16px] font-robotoMedium font-normal text-monoX dark:text-monoY"
                            >
                                {group.groupName}
                            </div>
                        </div>
                        <Table 
                            tableData={group} 
                            isLegendEnebled={groupIndex === groupsData.groups.length - 1}
                            colorLegend={groupsData.colorLegend}
                            marginTop={'12px'}
                            marginBottom={'3px'}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GroupTable;
